import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const CalendarContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    height: "700px",
    boxShadow: theme.shadows[2],
}));

export const CalendarWrapper = styled(Box)(({ theme }) => ({
    width: "100%",
    height: "100%",
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.default,
}));

export const DayCell = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    minHeight: "100px",
    textAlign: "center",
    cursor: "pointer",
    transition: "background-color 0.2s ease-in-out",
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
    width: "500px",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    margin: "auto",
    marginTop: theme.spacing(10),
}));

export const StyledModalButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    "&:hover": {
        backgroundColor: theme.palette.success.dark,
    },
}));

export const StyledSwitchContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginTop: theme.spacing(3),
}));

export const YearsLabel = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
}));